import { ButtonProps, ModalViewFormType } from '~types'

export const FORM_ERROR_VIEW: ModalViewFormType = {
  componentName: 'ModalViewFormError',
  title: 'Error',
  description: {
    html: '<p>Something went wrong. Please try again later.</p>'
  },
  ctas: [
    {
      id: 'form_error_button',
      componentName: 'Button',
      color: 'light',
      fill: 'hollow',
      justify: 'center',
      size: 'lg',
      isFullWidth: false,
      title: 'Close'
    } as ButtonProps
  ],
  iconName: 'exclamation_point'
}
